import React from 'react'

/**
 * Renders children when condition is true, otherwise renders fallback.
 * @param {Object} props
 * @param {boolean} props.condition - When true, render children; when false, render fallback
 * @param {React.ReactNode} [props.fallback=null] - Content to render when condition is false
 * @param {React.ReactNode} props.children - Content to render when condition is true
 * @returns {React.ReactNode}
 */
const ConditionalRender = ({condition, fallback = null, children}) => {
    return condition ? children : fallback
}

export default ConditionalRender
